import Vue from 'vue'
import Router from 'vue-router'
import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Router)

let boyangrouter = new Router({
mode:'history',
  routes: [{
      path: '/',
      name: 'home',
	  meta: {show: true },
      component: () => import('./views/Home.vue')
    },
	{
	  path: '/register',
	  name: 'register',
	  meta: {show: true },
	  component: () => import('./views/register.vue'),
	},
	{
	  path: '/forgetPwd',
	  name: 'forgetPwd',
	  meta: {show: true },
	  component: () => import('./views/ForgetPwd.vue'),
	},
	// end
    {
      path: '/news',
      name: 'news',
	  meta: {show: true },
      component: () => import('./views/News.vue'),
    },
    {
      path: '/newsdetails/:id',
      name: 'newsdetails',
	  meta: {show: true },
      component: () => import('./views/NewsDetails.vue'),
    },
    {
      path: '/product',
      name: 'product',
	  meta: {show: true },
      component: () => import('./views/Product.vue'),
    },
    {
      path: '/manage',
      name: 'manage',
      meta: {
        requireAuth: true,
      },
      component: () => import('./views/Manage.vue'),
	  redirect:'/manage/index',
      children: [{
          path: '/manage/column',
          name: 'column',
          component: () => import('./views/Manage/column/index.vue')
        },
        {
          path: '/manage/prodoct',
          name: 'prodoct',
          component: () => import('./views/Manage/prodoct/index.vue')
        },
        {
          path: '/manage/code',
          name: 'code',
          component: () => import('./views/Manage/code/index.vue')
        },
        {
          path: '/manage/index',
          name: 'index',
          component: () => import('./views/Manage/index/index.vue')
        },
		{
		  path: '/manage/distributor',
		  name: 'index',
		  component: () => import('./views/Manage/index/distributor.vue')
		},
        {
          path: '/manage/align',
          name: 'align',
          component: () => import('./views/Manage/certificate/align/index.vue')
        },
        {
          path: '/manage/user',
          name: 'user',
          component: () => import('./views/Manage/user/index.vue')
        },
        
       
      ]
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
boyangrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (getToken()) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default boyangrouter